interface Locatable {
  id: number;
  x: number;
  y: number;
}

export class SpatialHash<T extends Locatable> {
  private readonly cells = new Map<string, T[]>();

  constructor(private readonly cellSize: number) {}

  rebuild(items: readonly T[]): void {
    this.cells.clear();
    for (const item of items) {
      const key = this.keyFor(item.x, item.y);
      const cell = this.cells.get(key) ?? [];
      cell.push(item);
      this.cells.set(key, cell);
    }
  }

  queryCircle(x: number, y: number, radius: number): T[] {
    const minX = Math.floor((x - radius) / this.cellSize);
    const maxX = Math.floor((x + radius) / this.cellSize);
    const minY = Math.floor((y - radius) / this.cellSize);
    const maxY = Math.floor((y + radius) / this.cellSize);
    const matches: T[] = [];

    for (let cellX = minX; cellX <= maxX; cellX += 1) {
      for (let cellY = minY; cellY <= maxY; cellY += 1) {
        const cell = this.cells.get(`${cellX}:${cellY}`);
        if (cell) matches.push(...cell);
      }
    }

    return matches;
  }

  private keyFor(x: number, y: number): string {
    return `${Math.floor(x / this.cellSize)}:${Math.floor(y / this.cellSize)}`;
  }
}
